const BenefitsSection = () => {
  const benefits = [
    {
      icon: (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M40 10L45 25L60 20L50 35L65 40L50 45L60 60L45 55L40 70L35 55L20 60L30 45L15 40L30 35L20 20L35 25L40 10Z" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          <circle cx="40" cy="40" r="25" stroke="#1E88E5" strokeWidth="2" fill="none"/>
        </svg>
      ),
      title: 'Уникальные маршруты',
      description: 'Открываем места, которых нет в стандартных путеводителях.'
    },
    {
      icon: (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M40 15C26.7452 15 16 25.7452 16 39C16 52.2548 26.7452 63 40 63C53.2548 63 64 52.2548 64 39C64 25.7452 53.2548 15 40 15Z" stroke="#1E88E5" strokeWidth="2" fill="none"/>
          <path d="M40 25V39L50 49" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M25 39H20M60 39H55M40 20V15M40 63V58" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: 'Индивидуальный подход',
      description: 'Путешествие, созданное под ваши интересы и ритм.'
    },
    {
      icon: (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="30" cy="25" r="8" stroke="#1E88E5" strokeWidth="2" fill="none"/>
          <circle cx="50" cy="25" r="8" stroke="#1E88E5" strokeWidth="2" fill="none"/>
          <circle cx="40" cy="45" r="8" stroke="#1E88E5" strokeWidth="2" fill="none"/>
          <path d="M30 33C25 38 20 45 20 52C20 58 24 62 30 62H50C56 62 60 58 60 52C60 45 55 38 50 33" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          <path d="M32 45L28 52M48 45L52 52" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: 'Клуб друзей',
      description: 'Сообщество единомышленников и выгодные условия для своих.'
    },
    {
      icon: (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="40" cy="28" r="10" stroke="#1E88E5" strokeWidth="2" fill="none"/>
          <path d="M25 65V55C25 50 28 45 33 43C35 42 37 42 40 42C43 42 45 42 47 43C52 45 55 50 55 55V65" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          <path d="M50 20L55 15L60 20M55 15V25" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M20 50L15 55L20 60M15 55H25" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Опытные гиды',
      description: 'Эксперты с глубокими знаниями и любовью к своему делу.'
    },
    {
      icon: (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M40 15L42 28L50 22L45 35L58 35L48 42L52 55L40 48L28 55L32 42L22 35L35 35L30 22L38 28L40 15Z" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          <path d="M25 60C25 60 28 65 40 65C52 65 55 60 55 60" stroke="#1E88E5" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="40" cy="40" r="23" stroke="#1E88E5" strokeWidth="2" fill="none"/>
        </svg>
      ),
      title: 'Здоровый образ жизни',
      description: 'Путешествия, которые заряжают энергией и укрепляют тело.'
    }
  ];

  return (
    <div className="bg-white py-20">
      <div className="max-w-[1360px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <div className="w-20 h-20 flex items-center justify-center mb-6" style={{ backgroundColor: '#f0f8ff9e', borderRadius: '15px' }}>
                {benefit.icon}
              </div>
              <h3 className="font-mulish font-bold text-lg text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="font-open-sans text-sm text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BenefitsSection;
